import React, { useState } from 'react';
import { useMedia } from 'react-use';

const MobileFleetPlan = (props) => {
    return (
        <section>
            <div className="inner mobile-fleet-plan">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1 centered">
                        <h2 className="color-white bold text-left mt-0">ExeSIM Business Fleet Plans</h2>                    
                        <div className="items mb-4">
                            {props.data.plans && props.data.plans.map((item, index) => {
                                return (
                                    <Plan item={item} key={index} />
                                )
                            })}                                                        
                        </div>
                        <a href="https://files.exetel.com.au/cis/fleet/2025-10/CIS_Business_Mobile_Voice_Postpaid_Fleet.pdf" target="_blank" className="text-center">Critical information summary</a>
                        <p className="text-left font-small color-white">Unlimited international call countries are: Bangladesh, Canada, China, Greece, Hong Kong, India, Ireland, Japan, South Korea, Malaysia, New Zealand, Singapore, Thailand, UK and USA.</p>
                        <h2 className="color-white bold text-left">ExeGo Business Mobile broadband Plans</h2>
                        <div className="items mbb-items mb-4">
                            {props.data.mbbPlans && props.data.mbbPlans.map((item, index) => {
                                return (
                                    <div className="plan-container exe text-center" key={index}>
                                        <h5 className="bold m-0 color-lime">{item.title}</h5>
                                        <hr />
                                        <p className="price bold m-0">{item.price}</p>
                                        <small className="m-0">price includes GST</small>
                                        <hr />
                                        <p className="data bold m-0">{item.data}</p>
                                    </div>
                                )
                            })}
                        </div>
                        <a href="https://files.exetel.com.au/cis/fleet/2025-10/CIS_Business_Mobile_Broadband_Postpaid_Fleet.pdf" target="_blank" className="text-center">Critical information summary</a>   
                        <div className="data-pool-container">
                            <h3 className="mb-0">Data pool details</h3>
                            <div className="grid-items">
                                {props.data.data_pool && props.data.data_pool.map((item, index) => {                                         
                                    return (
                                        <div key={index}>
                                            <ul className="text-left list">
                                                {item.column.map((item, index) => {
                                                    if (item.children) {
                                                        return (
                                                            <li key={index}>
                                                                {item.content}           
                                                                {item.children.map((item, index) => {
                                                                    return (
                                                                        <p key={index}>{item}</p>
                                                                    )
                                                                })}
                                                            </li>
                                                        )
                                                    } else {
                                                        return (
                                                            <li key={index}>{item.content}</li>
                                                        )
                                                    }
                                                })}
                                            </ul>                                            
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const Plan = ({ item }) => {
    
    const [showMore, setShowMore] = useState(false);
    const isMobile = useMedia("(max-width: 992px)");

    const handleShowMore = (e) => {
        e.preventDefault();
        setShowMore(true);
    }

    return (
        <div className="plan-container text-center">
            <h5 className="bold m-0 color-lime">{item.title}</h5>
            <p className="price bold mb-0 mt-2">{item.price}</p>
            <small className="m-0">price includes GST</small>
            <hr />
            <p className="bold data m-0">{item.data}</p>
            <p className='mb-0 mt-2'>{item.copy}</p>
            <hr />
            <div className="d-lg-none d block">
                {isMobile && !showMore &&
                    <a className="text-center read-more" href="#" onClick={handleShowMore}>
                        read more
                        <img src="/images/arrow-down.svg" alt="arrow down" />
                    </a>
                }
            </div>
            {isMobile && showMore && <UnlimitedCallsEtc plan={item} />}
            {!isMobile && <UnlimitedCallsEtc plan={item} />}
            <hr />
            {item.downloadSpeedCapText && (
                <p className="m-0 mt-2 bold">{item.downloadSpeedCapText}</p>
            )}
        </div>
    )
}

const UnlimitedCallsEtc = (props) => {
    return (
        <React.Fragment>
            <h6>Unlimited calls & SMS</h6>
            <p className="m-0 bold">to Australian landlines & mobile numbers</p>
            <p className="m-0">(in Australia)</p>
            <hr />
            <h6>2,000 Text, Picture & Video MMS</h6>
            <p className="m-0 bold">to Australian mobiles (in Australia)</p>
            <hr />
            <div className="bottom-box">
                {props.plan.unlimited ? <div className="bold"><h6>Unlimited international calls & SMS</h6><p className="m-0">to 15 countries (see below)</p></div> : <p className="bold">PAYG international calls & SMS</p>}
            </div>
        </React.Fragment>
    );
}

export default MobileFleetPlan



// WEBPACK FOOTER //
// ./resources/assets/js/modules/mobileFleet/MobileFleetPlan.js